// extracted by mini-css-extract-plugin
export default {"resultCard":"Result_resultCard__BvyVY","actions":"Result_actions__yJfEH"};